module.exports = __webpack_public_path__ + "static/media/down.28f30160.svg";